<template>
    <div class="bg-white">
        <Head>
            <title>Правила перебування на озерах Хвиля</title>
        </Head>
        <Header :cart-count="cartCount"/>
        <div class="mx-auto max-w-2xl px-4 py-4 sm:px-6 sm:py-8 lg:max-w-7xl lg:px-8">
            <h2 class="text-4xl">Правила</h2>
            <h3 class="text-2xl mt-8">Список заборонених знарядь для ловлі риби</h3>
            <p class="my-4 leading-7"><b>Ятір.</b> Сітка, виготовлена з плетених вербових прутів або дроту, натягнута на обруч</p>
            <p class="my-4 leading-7"><b>«Доріжка».</b> (волосінна зяброва сітка, яка випускається у воду і витягується на гумовому амортизаторі)</p>
            <p class="my-4 leading-7"><b>«Павук»</b> розміром більше 1х1 метрів, з вічком понад 10 міліметрів</p>
            <p class="my-4 leading-7"><b>«Парашут».</b> Конусоподібна мережева снасть, діаметром від 5 до 10 метрів, по периметру якої розташовані свинцеві грузила. Застосовують, як правило, на швидких річках, перекатах, накидаючи на обрану ділянку акваторії. По грузилам затягується мотузка і риба опиняється в сітці.</p>
            <p class="my-4 leading-7"><b>«Екран»</b> або «телевізор». Маломірна прямокутна зяброва сітка з поплавками по верхньому ряду і вантажем внизу. Запускається і витягується з водойми на гумовому амортизаторі.</p>
            <p class="my-4 leading-7"><b>«Косинка».</b> Різновид «телевізора» трикутної форми, використовується переважно для підлідного лову риби біля дна.</p>
            <p class="my-4 leading-7"><b>Будь-які промислові сітки:</b> відціджуючі — неводи, бредні, волока, і ставні — тристінки, путанки.</p>
            <p class="my-4 leading-7"><b>Острога або ості.</b> Подоба вил із зазубреними вістрями.</p>
            <p class="my-4 leading-7"><b>Перемет.</b> Донна снасть з гострими гачками, які прив'язані до шнурів.</p>
            <p class="my-4 leading-7"><b>Драч.</b> Колюче знаряддя для вилову методом багріння. Наварені на важку блешню великі гострі гачки. Більша частина риби, що потрапила на драч, зривається і гине від отриманих ран.</p>
            <p class="my-4 leading-7"><b>Електровудка.</b> Пристосування для вилову риби у водоймах за допомогою потужного електророзряду. Залежно від потужності, це знаряддя лову здатне знищити все живе: від риби та ікри — до планктону і найдрібніших мікроорганізмів в радіусі від 5 до 20 м.</p>
            <h3 class="text-2xl mt-8">Попередження</h3>
            <p class="my-4 leading-7 rules-warning rules-warning-grey">У випадку підозри на порушення правил чи тарифних умов, ПП «Хвиля-2007» та його уповноважені представники залишають за собою право на регулярну перевірку садків, знарядь для ловлі риби тощо.</p>
            <p class="my-4 leading-7 rules-warning rules-warning-red">Виявлення порушення будь якого з правил чи тарифних умов призводить до негайного припинення рибалки без повернення грошових коштів платнику і конфіскаціі всієї виловленої риби.</p>
            <p class="mt-10 leading-7">Здійснення оплати означає погодження з загальними правилами та умовами тарифу.</p>
        </div>
    </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import Header from "@/Component/Header.vue";
export default {
    components: {
        Header,
        Head,
    },
    props: {
        cartCount: {
            type: Number,
            default: 0
        }
    }
}
</script>
